import {defaultIO} from "../DefaultIO";
import {ShoppingValueObject} from "../../model/vo/content/ShoppingValueObject";
import {httpClient} from "../HttpClient";
import {ShoppingPresentationValueObject} from "../../model/vo/content/ShoppingPresentationValueObject";
import {userInfo} from "node:os";

export const ShoppingIO = {
    ...defaultIO(
        '/api/v3/contents/shoppings',
        ShoppingValueObject.construct
    ),
    getData(externalId:string,requiredImageCount:number,isParticipating:boolean,shoppingPathJointId:string | null ): Promise<ShoppingPresentationValueObject> {
        const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent)

        let osType = 'Android'

        if (isIOS) osType = 'IOS'

        console.log(isParticipating,shoppingPathJointId)

        // const url = `/api/v3/contents/shoppings/presentation?externalId=${externalId}&osType=${osType}&requiredImageCount=${requiredImageCount}`
        const url = `/api/v3/contents/shoppings/presentation?externalId=${externalId}&osType=${osType}&requiredImageCount=${requiredImageCount}&isParticipating=${isParticipating}`+ (isParticipating? `&idEqual=${shoppingPathJointId}` : ``)

        console.log(`/api/v3/contents/shoppings/presentation?externalId=${externalId}&osType=${osType}&requiredImageCount=${requiredImageCount}&isParticipating=${isParticipating}`+ (isParticipating? `&idEqual=${shoppingPathJointId}` : ``))

        return httpClient.get(
            url
            , ShoppingPresentationValueObject.construct)
        },
}